import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { progressReducer } from './reducer';


@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature('progress', progressReducer),
  ]
})
export class ProgressStoreModule { }
